import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-469a245f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-visitor-form" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "请填写来访人信息", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "请填写访问信息", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "请填写被访人信息", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title",
  style: {"margin-top":"20px"}
}, "更多信息", -1))
const _hoisted_8 = {
  key: 0,
  class: "van-overlay"
}
const _hoisted_9 = { class: "van-popup van-popup--center van-dialog" }
const _hoisted_10 = { class: "van-dialog__content" }
const _hoisted_11 = { class: "van-dialog__message" }
const _hoisted_12 = ["data-clipboard-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_choose_visitor_target = _resolveComponent("choose-visitor-target")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_form, { onSubmit: $setup.onSubmit }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_van_radio_group, {
              modelValue: $setup.checkedRadio,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedRadio) = $event)),
              direction: "horizontal",
              "icon-size": "18",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_radio, {
                  name: "1",
                  style: {"margin-right":"60px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("由我填写")
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_radio, { name: "2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("由来访人自己填写")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            ($setup.checkedRadio == '1')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.person_lists, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-visitor-item",
                      key: item.key
                    }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "form-delete",
                            onClick: ($event: any) => ($setup.deletePerson(index))
                          }, "删除", 8, _hoisted_4))
                        : _createCommentVNode("", true),
                      _createVNode(_component_van_cell_group, { inset: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_field, {
                            modelValue: item.name,
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                            maxlength: "20",
                            required: "",
                            name: 'name' + index,
                            label: `来访人${index + 1 < 2 ? '' : index + 1}`,
                            placeholder: `请输入来访人${index + 1 < 2 ? '' : index + 1}姓名`,
                            rules: [{ required: true, message: `请输入姓名` }]
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "placeholder"]),
                          _createVNode(_component_van_field, {
                            modelValue: item.mobile,
                            "onUpdate:modelValue": ($event: any) => ((item.mobile) = $event),
                            type: "tel",
                            name: 'mobile' + index,
                            label: "手机号",
                            maxlength: "11",
                            required: "",
                            placeholder: "请输入来访人手机号",
                            rules: [
                  { required: true, message: '请输入手机号' },
                  { pattern: $setup.validate.mobile.reg, message: $setup.validate.mobile.msg }
                ]
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]),
                          _createVNode(_component_van_field, {
                            modelValue: item.email,
                            "onUpdate:modelValue": ($event: any) => ((item.email) = $event),
                            type: "email",
                            name: 'email' + index,
                            label: "邮箱",
                            placeholder: "请输入来访人邮箱"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                          _createVNode(_component_van_field, {
                            modelValue: item.car_number,
                            "onUpdate:modelValue": ($event: any) => ((item.car_number) = $event),
                            name: 'car_number' + index,
                            label: "车牌号",
                            placeholder: "请输入车牌号"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "add-visitor-btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.addPerson && $setup.addPerson(...args)))
                  }, [
                    _createVNode(_component_van_icon, { name: "plus" }),
                    _createTextVNode(" 新增来访人")
                  ])
                ], 64))
              : _createCommentVNode("", true),
            ($setup.checkedRadio == '2')
              ? (_openBlock(), _createBlock(_component_van_cell_group, {
                  key: 1,
                  inset: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      label: "来访人数",
                      required: "",
                      modelValue: $setup.formData.person_num,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.person_num) = $event)),
                      placeholder: "请输入来访人数",
                      rules: [
                { required: true, message: '请输入来访人数' },
                { pattern: $setup.validate.number.reg, message: $setup.validate.number.msg }
              ]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_5,
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.person_reason,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.person_reason) = $event)),
                  name: "person_reason",
                  label: "来访原因",
                  readonly: "",
                  "is-link": "",
                  required: "",
                  "right-icon": "arrow",
                  maxlength: "100",
                  placeholder: "请选择来访原因",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.reasonData.show = true)),
                  rules: [{ required: true, message: '请选择来访原因' }]
                }, null, 8, ["modelValue"]),
                ($setup.personReason == '其他')
                  ? (_openBlock(), _createBlock(_component_van_field, {
                      key: 0,
                      modelValue: $setup.reasonData.person_reason,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.reasonData.person_reason) = $event)),
                      required: "",
                      maxlength: "100",
                      placeholder: "请输入来访原因",
                      rules: [{ required: true, message: '请输入来访原因' }]
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_van_popup, {
                  show: $setup.reasonData.show,
                  "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.reasonData.show) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_picker, {
                      "columns-field-names": { text: 'text' },
                      columns: $setup.reasonData.visit_reason,
                      onConfirm: $setup.reasonData.pickerConfirm,
                      onCancel: _cache[6] || (_cache[6] = ($event: any) => ($setup.reasonData.show = false))
                    }, null, 8, ["columns", "onConfirm"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.person_time_start.fieldValue,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.person_time_start.fieldValue) = $event)),
                  "is-link": "",
                  readonly: "",
                  required: "",
                  name: "datetimePicker",
                  label: "来访开始时间",
                  placeholder: "请选择来访开始时间",
                  "right-icon": "arrow",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.person_time_start.show = true))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: $setup.person_time_start.show,
                  "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (($setup.person_time_start.show) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      type: "datetime",
                      modelValue: $setup.person_time_start.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.person_time_start.value) = $event)),
                      "min-date": $setup.person_time_start.minDate,
                      filter: $setup.person_time_start.filter,
                      onConfirm: $setup.person_time_start.confirm,
                      onCancel: _cache[11] || (_cache[11] = ($event: any) => ($setup.person_time_start.show = false))
                    }, null, 8, ["modelValue", "min-date", "filter", "onConfirm"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.person_time_end.fieldValue,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.person_time_end.fieldValue) = $event)),
                  "is-link": "",
                  readonly: "",
                  name: "datetimePicker",
                  required: "",
                  label: "来访结束时间",
                  placeholder: "请选择来访结束时间",
                  "right-icon": "arrow",
                  onClick: $setup.clickTimeEnd
                }, null, 8, ["modelValue", "onClick"]),
                _createVNode(_component_van_popup, {
                  show: $setup.person_time_end.show,
                  "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (($setup.person_time_end.show) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      type: "datetime",
                      modelValue: $setup.person_time_end.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.person_time_end.value) = $event)),
                      "min-date": $setup.person_time_end.minDate,
                      "max-date": $setup.person_time_end.maxDate,
                      onConfirm: $setup.person_time_end.confirm,
                      onCancel: _cache[15] || (_cache[15] = ($event: any) => ($setup.person_time_end.show = false))
                    }, null, 8, ["modelValue", "min-date", "max-date", "onConfirm"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                ($setup.userInfo?.user_type == '1')
                  ? (_openBlock(), _createBlock(_component_van_field, {
                      key: 0,
                      modelValue: $setup.formData.visitor_target_name,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.formData.visitor_target_name) = $event)),
                      "is-link": "",
                      readonly: "",
                      name: "picker",
                      label: "被访对象",
                      required: "",
                      placeholder: "请选择被访对象",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.chooseVisitorTargetShow = true)),
                      "right-icon": "arrow",
                      rules: [{ required: true, message: '请选择被访对象' }]
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                ($setup.userInfo?.user_type == '3')
                  ? (_openBlock(), _createBlock(_component_van_field, {
                      key: 1,
                      modelValue: $setup.formData.visitor_target_name,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.formData.visitor_target_name) = $event)),
                      readonly: "",
                      name: "picker",
                      label: "被访对象",
                      required: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                ($setup.userInfo?.user_type == '8')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_van_field, {
                        modelValue: $setup.formData.visit_house_number,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.formData.visit_house_number) = $event)),
                        "is-link": "",
                        readonly: "",
                        name: "picker",
                        label: "被访对象",
                        required: "",
                        placeholder: "请选择被访对象",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.formData.showPicker = true)),
                        "right-icon": "arrow",
                        rules: [{ required: true, message: '请选择被访对象' }]
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_van_popup, {
                        show: $setup.formData.showPicker,
                        "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => (($setup.formData.showPicker) = $event)),
                        position: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_picker, {
                            "columns-field-names": { text: 'house_number' },
                            columns: $setup.formData.house_arr,
                            onConfirm: $setup.formData.houseConfirm,
                            onCancel: _cache[22] || (_cache[22] = ($event: any) => ($setup.formData.showPicker = false))
                          }, null, 8, ["columns", "onConfirm"])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_name,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.formData.visit_user_name) = $event)),
                  name: "visit_user_name",
                  label: "被访人",
                  maxlength: "20",
                  required: "",
                  placeholder: "请输入被访人姓名",
                  rules: [{ required: true, message: `请输入被访人姓名` }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_mobile,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.formData.visit_user_mobile) = $event)),
                  type: "tel",
                  name: "visit_user_mobile",
                  label: "被访人手机号",
                  required: "",
                  maxlength: "11",
                  placeholder: "被访人手机号",
                  rules: [
              { required: true, message: '请输入被访人手机号' },
              { pattern: $setup.validate.mobile.reg, message: $setup.validate.mobile.msg }
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_van_field, {
                  modelValue: $setup.formData.visit_user_email,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.formData.visit_user_email) = $event)),
                  type: "email",
                  name: "visit_user_email",
                  label: "被访人邮箱",
                  placeholder: "请输入被访人邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            ($setup.formData.visit_diy_field.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_7,
                  _createVNode(_component_van_cell_group, { inset: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formData.visit_diy_field, (field) => {
                        return (_openBlock(), _createBlock(_component_van_field, {
                          key: field.id,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          name: field.id,
                          label: field.title,
                          required: field.required,
                          placeholder: `请输入${field.title}`,
                          rules: [{ required: field.required, message: `请输入${field.title}` }]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "required", "placeholder", "rules"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交申请 ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    ($setup.copyData.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.copyData.text), 1),
              _createElementVNode("div", {
                class: "copy-view",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => ($setup.copyCurrentUrl && $setup.copyCurrentUrl(...args))),
                "data-clipboard-text": $setup.copyData.url
              }, " 复制来访人信息填写链接 ", 8, _hoisted_12)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_choose_visitor_target, {
      show: $setup.chooseVisitorTargetShow,
      "onUpdate:show": _cache[28] || (_cache[28] = ($event: any) => (($setup.chooseVisitorTargetShow) = $event)),
      multiple: "",
      onConfirm: $setup.visitorTargetConfirm
    }, null, 8, ["show", "onConfirm"])
  ], 64))
}